(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  const PRODUCT_RE = /\/products\/[^/?#]+/;
  let lastUrl = '';
  let lastTime = 0;

  function pdpUrl(link) {
    if (!link || !link.getAttribute('href')) return null;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return null;
    }

    if (url.origin !== window.location.origin) return null;
    if (!PRODUCT_RE.test(url.pathname)) return null;

    return url.href;
  }

  function onClick(e) {
    if (!e.target || !e.target.closest) return;

    const link = e.target.closest('a[href]');
    const url = pdpUrl(link);
    if (!url) return;

    // Ignore clicks that point at the product page you're already on
    if (url.split('?')[0] === window.location.href.split('?')[0]) return;

    const now = Date.now();
    if (url === lastUrl && now - lastTime < 500) return;
    lastUrl = url;
    lastTime = now;

    window.dataLayer.push({
      event: 'pdp_click_through',
      event_label: url.split('?')[0].replace(window.location.origin, ''),
      event_action: window.location.href
    });
  }

  // Capture phase, delegated on document: survives Section Rendering API
  // re-renders, infinite scroll, drawers, and stopPropagation() in components.
  document.addEventListener('click', (e) => { if (e.button === 0) onClick(e); }, true);
  document.addEventListener('auxclick', (e) => { if (e.button === 1) onClick(e); }, true);
})();